/**
 * Flint Fires - FAQ Accordion
 * Accessible accordion with keyboard navigation
 */

class FlintFAQAccordion {
  constructor(section) {
    this.section = section;
    this.items = this.section.querySelectorAll('[data-faq-item]');
    
    if (this.items.length === 0) return;
    
    this.init();
  }
  
  init() {
    console.log('🔥 Flint FAQ Accordion initialized');
    
    // Set up each FAQ item
    this.items.forEach((item, index) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const answer = item.querySelector('[data-faq-answer]');
      
      if (!trigger || !answer) return;
      
      // Generate unique IDs for accessibility
      const id = `faq-${Date.now()}-${index}`;
      trigger.setAttribute('id', `${id}-trigger`);
      answer.setAttribute('id', `${id}-answer`);
      trigger.setAttribute('aria-controls', `${id}-answer`);
      
      // Click event
      trigger.addEventListener('click', () => {
        this.toggleItem(item, trigger, answer);
      });
      
      // Keyboard navigation
      trigger.addEventListener('keydown', (e) => {
        this.handleKeyboard(e, trigger);
      });
    });
  }
  
  toggleItem(item, trigger, answer) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      // Collapse
      trigger.setAttribute('aria-expanded', 'false');
      item.removeAttribute('data-expanded');
      console.log('🔽 FAQ collapsed');
    } else {
      // Expand
      trigger.setAttribute('aria-expanded', 'true');
      item.setAttribute('data-expanded', 'true');
      console.log('🔼 FAQ expanded');
    }
  }
  
  handleKeyboard(e, trigger) {
    const triggers = Array.from(this.section.querySelectorAll('[data-faq-trigger]'));
    const currentIndex = triggers.indexOf(trigger);
    
    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        // Focus next trigger
        const nextIndex = (currentIndex + 1) % triggers.length;
        triggers[nextIndex].focus();
        break;
        
      case 'ArrowUp':
        e.preventDefault();
        // Focus previous trigger
        const prevIndex = currentIndex === 0 ? triggers.length - 1 : currentIndex - 1;
        triggers[prevIndex].focus();
        break;
        
      case 'Home':
        e.preventDefault();
        // Focus first trigger
        triggers[0].focus();
        break;
        
      case 'End':
        e.preventDefault();
        // Focus last trigger
        triggers[triggers.length - 1].focus();
        break;
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('.flint-faq-accordion');
  faqSections.forEach(section => {
    new FlintFAQAccordion(section);
  });
});

// Reinitialize on Shopify section events (theme editor)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.flint-faq-accordion');
    if (section) {
      new FlintFAQAccordion(section);
    }
  });
}
